export const SOCIAL_LINKS = {
  github: 'https://github.com/pro1code1hack',
  linkedin: 'https://linkedin.com/in/yehor-dremliuha',
  email: 'western.ant2@gmail.com',
};

export const RESUME_URL = '/Yehor_Dremliuha_CV_2025.pdf';

export const NAV_ITEMS = [
  { id: 'skills', label: 'Skills' },
  { id: 'experience', label: 'Experience' },
  { id: 'projects', label: 'Projects' },
  { id: 'highlights', label: 'Highlights' },
  { id: 'contact', label: 'Contact' },
];

export const STATS = [
  { value: '5+', label: 'Years Experience' },
  { value: '1B+', label: 'Events/Year' },
  { value: '7', label: 'Products Shipped' },
  { value: '1,100+', label: 'GitHub Stars' },
];
